<span [innerHTML]="getHtml(text)"></span>
